import { Component, ChangeDetectionStrategy } from "@angular/core";

import { RouterModule } from "@angular/router";
import {
  ARTICLES,
  BlogArticle,
  BlogCategory,
  CATEGORY_LABELS,
} from "./articles";

const published = ARTICLES.filter((a) => !a.draft);
const featured = published.find((a) => a.featured) ?? published[0];

@Component({
  selector: "app-blog",
  templateUrl: "./blog.component.html",
  styleUrls: ["./blog.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterModule],
})
export class BlogComponent {
  featuredPost: BlogArticle | undefined = featured;
  posts: BlogArticle[] = published.filter((a) => a !== featured);

  labels = CATEGORY_LABELS;

  // unique categories present among published articles, ordered by CATEGORY_LABELS key order
  categories: BlogCategory[] = (
    Object.keys(CATEGORY_LABELS) as BlogCategory[]
  ).filter((c) => published.some((a) => a.category === c));

  showFilters = this.categories.length >= 2;

  activeCategory: BlogCategory | "all" = "all";

  get visiblePosts(): BlogArticle[] {
    return this.activeCategory === "all"
      ? this.posts
      : published.filter((a) => a.category === this.activeCategory);
  }

  setCategory(c: BlogCategory | "all"): void {
    this.activeCategory = c;
  }
}
